import API, { setAuthToken } from "@core/api/api";

export const login = async (credentials) => {
  const response = await API.post("/auth/login", credentials);
  return response.data;
};

export const register = async (userData) => {
  const response = await API.post("/auth/register", userData);
  return response.data;
};

export const logout = async () => {
  const response = await API.post("/auth/logout");
  return response.data;
};

export const getCurrentUser = async () => {
  if (!localStorage.getItem("token")) {
    return null;
  }
  setAuthToken(localStorage.getItem("token"));
  const response = await API.get("/auth/me");
  return response.data;
};

export const forgotPassword = async (data) => {
  const response = await API.post("/auth/forgot-password", data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await API.post("/auth/reset-password", data);
  return response.data;
};

export const verifyResetToken = async (data) => {
  const response = await API.post("/auth/verify-reset-token", data);
  return response.data;
};
